/** Keys for locking attachment pipelines. */
export const LOCKING_ATTACHMENT_KIND = {
  BULLDOG: 'bulldog',
  /** Bull Dog seated 12 mm deeper, with 12 mm taken off the engulf height. */
  BULLDOG_V2: 'bulldog_v2',
  FOUR_HOLE_ATTACHMENT: 'four_hole_attachment',
  /** Russian 5-hole adapter — 4-hole pipeline, different GLB (4_pin + center_pin). */
  RUSSIAN_ATTACHMENT: 'russian_attachment',
  /** Bowl adapter — 4-hole pipeline, but the shell closes with a DOME, not a flat cap. */
  INNER_ATTACHMENT: 'inner_attachment',
};

/** True for every Bull Dog variant (same GLB, same pipeline, different height). */
export function isBulldogKind(kind) {
  return kind === LOCKING_ATTACHMENT_KIND.BULLDOG
    || kind === LOCKING_ATTACHMENT_KIND.BULLDOG_V2;
}
